import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

export interface AskSimpoProject {
  id: string;
  name: string;
  description: string;
  instructions: string;
  starred: boolean;
  created_at: string;
  updated_at: string;
  chat_count: number;
  file_count: number;
}

export interface AskSimpoProjectListResponse {
  projects: AskSimpoProject[];
}

@Injectable({ providedIn: 'root' })
export class AskSimpoProjectService {
  private readonly base = environment.askSimpoApiUrl;

  constructor(private http: HttpClient) {}

  private ctxHeaders(extra: Record<string, string> = {}): HttpHeaders {
    return new HttpHeaders({
      accept: 'application/json',
      'X-Business-Id': localStorage.getItem('businessId') || '',
      'X-Staff-Id': localStorage.getItem('staffId') || '',
      ...extra,
    });
  }

  getProjects(): Observable<AskSimpoProjectListResponse> {
    return this.http.get<AskSimpoProjectListResponse>(
      `${this.base}/projects?sort=updated_at`,
      { headers: this.ctxHeaders() },
    );
  }

  deleteProject(projectId: string): Observable<unknown> {
    return this.http.delete(`${this.base}/projects/${projectId}`, {
      headers: new HttpHeaders({ accept: 'application/json' }),
    });
  }

  setProjectStarred(projectId: string, starred: boolean): Observable<unknown> {
    return this.http.patch(
      `${this.base}/projects/${projectId}`,
      { starred },
      { headers: this.ctxHeaders({ 'Content-Type': 'application/json' }) },
    );
  }
}
